<template>
  <div class="w-full px-2 sm:px-0">
    <TabGroup @change="updateActiveTab">
      <TabList class="flex space-x-1 rounded-xl bg-gray-100 p-1">
        <!-- lista de funcionários -->
        <Tab as="template" v-slot="{ selected }">
          <button
            :class="[
              'w-full rounded-lg py-2.5 text-sm font-medium leading-5 color-app',
              'ring-white/60 ring-offset-2 ring-offset-green-app focus:outline-none focus:ring-2',
              selected
                ? 'bg-white active-tab shadow'
                : 'text-blue-100 hover:text-[#177835]',
            ]"
          >
            <div class="flex items-center justify-center">
              <span>
                <PhUserList class="w-5 h-5 text-gray-700" />
              </span>
              <h2 class="ml-1">Relatos</h2>
            </div>
          </button>
        </Tab>

        <!-- cadastros -->
        <Tab as="template" v-slot="{ selected }">
          <button
            :class="[
              'w-full rounded-lg py-2.5 text-sm font-medium leading-5 color-app',
              'ring-white/60 ring-offset-2 ring-offset-green-app focus:outline-none focus:ring-2',
              selected
                ? 'bg-white active-tab shadow'
                : 'text-blue-100 hover:text-[#177835]',
            ]"
          >
            <div class="flex items-center justify-center">
              <span>
                <!-- <i class="fa-regular fa-address-card"></i> -->
                <PhListPlus class="w-5 h-5 text-gray-700" />
              </span>
              <h2 class="ml-1">Cadastros</h2>
            </div>
          </button>
        </Tab>

        <!-- estatisticas -->
        <Tab as="template" v-slot="{ selected }">
          <button
            :class="[
              'w-full rounded-lg py-2.5 text-sm font-medium leading-5 color-app',
              'ring-white/60 ring-offset-2 ring-offset-green-app focus:outline-none focus:ring-2',
              selected
                ? 'bg-white active-tab shadow'
                : 'text-blue-100 hover:text-[#177835]',
            ]"
          >
            <div class="flex items-center justify-center">
              <span>
                <!-- <i class="fa-regular fa-address-card"></i> -->
                <PhChartLineUp class="w-5 h-5 text-gray-700" />
              </span>
              <h2 class="ml-1">Estatisticas</h2>
            </div>
          </button>
        </Tab>
      </TabList>

      <TabPanels class="mt-2">
        <TabPanel
          :class="[
            'rounded-xl bg-white pt-3 pb-3',
            'ring-white/60 ring-offset-2 focus:outline-none focus:ring-2',
          ]"
        >
          <slot name="relatos" />
        </TabPanel>

        <TabPanel
          :class="[
            'rounded-xl bg-white pt-3 pb-3',
            'ring-white/60 ring-offset-2 focus:outline-none focus:ring-2',
          ]"
        >
          <slot name="cadastros" />
        </TabPanel>

        <TabPanel
          :class="[
            'rounded-xl bg-white pt-3 pb-3',
            'ring-white/60 ring-offset-2 focus:outline-none focus:ring-2',
          ]"
        >
          <slot name="statistics" />
        </TabPanel>
      </TabPanels>
    </TabGroup>
  </div>
</template>

<script setup>
import { dataRcd } from "../../store";
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from "@headlessui/vue";
import { PhUserList, PhListPlus, PhChartLineUp } from "@phosphor-icons/vue";
import { onMounted } from "vue";

function updateActiveTab(index) {
  const tabs = ["relatos", "cadastros", "statistics"];
  dataRcd.dispatch("setActiveTab", tabs[index]);
}
</script>

<style lang="scss" scoped>
.ring-offset-green-app {
  --tw-ring-offset-color: #91cb25;
}
.color-app {
  color: #2c3e50;
  font-weight: bold;
}
.active-tab {
  color: #177835;
  text-shadow: 5px 5px 15px #ccc;
}
</style>
